import { MemberGrid } from "@design-system/components";
import { AboutUsData } from "@modules/about-us/data/mockData";
import { trans } from "@mongez/localization";

interface BoardOfDirectorsContentProps {
  data?: AboutUsData;
}

/**
 * Board of Directors content component
 * Displays board members and executive management in a grid layout
 */
export function BoardOfDirectorsContent({
  data,
}: BoardOfDirectorsContentProps) {
  if (!data) return null;

  return (
    <div className="pb-16">
      <MemberGrid
        title={trans("aboutUsPage.leadership.boardOfDirectors.title")}
        members={data.boardMembers}
      />
      <MemberGrid
        title={trans("aboutUsPage.leadership.executiveManagement.title")}
        members={data.executiveMembers}
      />
    </div>
  );
}
